import { storage } from "@/app-utils/proxy-storage.ts";
import { AUTH_KEY, TOKEN_KEY, X_AUTH_KEY } from "@/settings/settings.ts";

export const getCredentialsHeaders = (): HeadersInit => {
  const token = storage[TOKEN_KEY];

  return token
    ? {
        [AUTH_KEY]: `Bearer ${token}`,
        [X_AUTH_KEY]: `Bearer ${token}`,
      }
    : {};
};
